import React from 'react';
import { observable, runInAction, makeObservable } from 'mobx';
import { isSome, renderIf, translate } from 'core/utils';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { defaultTemplate } from 'core/hoc';
import NumberFormat from 'react-number-format';
import { NotifyOutsideClick } from 'core/components';
import moment from 'moment';
import PropTypes from 'prop-types';
class DatePickerTemplate extends React.Component {
	@observable isCalendarOpen = false;
	@observable errorMessage = undefined;

	constructor(props) {
		super(props);
		makeObservable(this);
		this.form = props.form;
		this.fieldType = props.fieldType;
		this.compareWithDefaults = props.compareWithDefaults;
		this.minDate = props.minDate;
		this.maxDate = props.maxDate;
		this.rootStore = props.rootStore;
		this.isFilter = props.isFilter;
		this.format = props.format;
		this.withoutYear = props.withoutYear;
		this.setIsValidDate = props.setIsValidDate;
		this.checkDatesOnDateChange = props.checkDatesOnDateChange;
	}

	toggleCalendar = () => {
		runInAction(() => {
			this.isCalendarOpen = true;
		});
	};

	closeCalendar = () => {
		runInAction(() => {
			this.isCalendarOpen = false;
		});
	};

	handleDayClick = (day, modifiers = {}) => {
		if (!modifiers.disabled) {
			this.props.field.clear();
			this.props.field.set(
				day.toLocaleDateString(window.navigator.userLanguage || window.navigator.language, {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				})
			);
			runInAction(() => {
				this.isCalendarOpen = false;
			});
		} else {
			if (day < this.props.minDate) {
				this.rootStore.notificationStore.error(['FILTER.INVALIDENDDATE']);
			}
			if (day > this.props.maxDate) {
				this.rootStore.notificationStore.error(['FILTER.INVALIDSTARTDATE']);
			}
		}
	};

	validateDate = value => {
		const isValidDate = moment(value.formattedValue).isValid();
		if (this.setIsValidDate != null) {
			this.setIsValidDate(isValidDate);
		}
		if (!isValidDate) {
			if (!this.isFilter) {
				runInAction(() => {
					if (value.formattedValue === '') {
						this.errorMessage = translate('EMPTYDATE');
					} else {
						this.errorMessage = translate('INVALIDDATE');
					}
					this.props.field.set(value.formattedValue);
					if (this.form && this.form.has('selectedDefault')) {
						this.form.$('selectedDefault').reset();
					}
				});
			} else {
				this.props.field.set(value.formattedValue);
			}
		} else {
			if (this.checkDatesOnDateChange) {
				this.checkDatesOnDateChange();
			}
			this.props.field.clear();
			this.props.field.set(value.formattedValue);
			if (this.compareWithDefaults) {
				this.compareWithDefaults(value, this.fieldType);
			}
			runInAction(() => {
				this.errorMessage = undefined;
			});
		}
	};

	setFormat(format) {
		for (var i = 0; i < format.length; i++) {
			if (
				format.charAt(i) !== '.' &&
				format.charAt(i) !== '-' &&
				format.charAt(i) !== '/' &&
				format.charAt(i) !== '#'
			) {
				format = format.replace(format.charAt(i), '#');
			}
		}
		return format;
	}

	setMask(mask) {
		const maskArray = mask.split('');
		for (var i = 0; i < maskArray.length; i++) {
			if (maskArray[i] === '.' || maskArray[i] === '-' || maskArray[i] === '/') {
				maskArray.splice(i, 1);
			}
		}
		return maskArray;
	}

	clearValues = () => {
		this.props.field.clear();
		if (this.form && this.form.has('selectedDefault')) {
			this.form.$('selectedDefault').clear();
		}
	};

	render() {
		const { t, minDate, maxDate, title, field, format, disabled, showValidation } = this.props;
		let currentYear;
		let currentMonth;
		if (this.withoutYear) {
			currentYear = moment().year();
			currentMonth = moment().month();
		}
		return (
			<div className="inputgroup pos--rel">
				<div>
					<label htmlFor={field.id}>
						{title ? t(field.label, { title: title }) : t(field.label)}{' '}
						{field.rules && field.rules.indexOf('required') !== -1 ? (
							<span className="type--color--warning">*</span>
						) : null}
					</label>
				</div>

				{renderIf(isSome(this.errorMessage) && showValidation)(
					<p className="type--tny type--color--error spc--bottom--tny">{this.errorMessage}</p>
				)}
				{renderIf(isSome(field.error))(
					<p className="type--tny type--color--error spc--bottom--tny">{t(field.error)}</p>
				)}

				<NotifyOutsideClick action={this.closeCalendar}>
					<section className="pos--rel">
						<NumberFormat
							placeholder={format}
							format={this.setFormat(format)}
							mask={this.setMask(format)}
							className="input input--med input--date"
							onFocus={this.toggleCalendar}
							value={field.value}
							onValueChange={values => this.validateDate(values)}
							disabled={disabled}
						></NumberFormat>
						{renderIf(field.value) && field.value != '' && !disabled && (
							<span className="input__clear" onClick={this.clearValues}></span>
						)}
						<div className="DayPickerInput-OverlayWrapper">
							<div className="DayPickerInput-Overlay">
								{renderIf(this.isCalendarOpen && !disabled)(
									<DayPicker
										selectedDays={moment(field.value, format).toDate()}
										value={field.value}
										month={this.withoutYear ? new Date(currentYear, currentMonth) : undefined}
										fromMonth={this.withoutYear ? new Date(currentYear, 0) : undefined}
										toMonth={this.withoutYear ? new Date(currentYear, 11) : undefined}
										onDayClick={this.handleDayClick}
										disabledDays={{
											before: minDate ? minDate : null,
											after: maxDate ? maxDate : null,
										}}
									></DayPicker>
								)}
							</div>
						</div>
					</section>
				</NotifyOutsideClick>
			</div>
		);
	}
}

DayPicker.propTypes = {
	selectedDays: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

export default defaultTemplate(DatePickerTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/forms/DatePickerTemplate.js